<template>
  <div class="site-footer text-center">

    <div class="footer-holder">
      <!-- for css -->
    </div>

    <div class="footer-main bg-theme-sec pt-5">
      
      <div class="sp-bar">
        <div class="container">
          <div class="d-flex align-items-center justify-content-between py-1">
            
            <!-- logo -->
            <div class="d-flex align-items-center">
              <span class="mr-2">
                <img 
                  src="/static/img/the_logo.png?v2" 
                  class=""
                  style="width: 50px;height:50px;"
                >
              </span>
              <span>
                JGN METAVERSE
              </span>
            </div>

            <!-- link -->
            <div class="sp-lins ">
              <a href="https://twitter.com/JGNDeFi" class="mx-2">
                <i class="fab fa-twitter"></i>
              </a>

              <a href="https://t.me/JGNDeFi" class="mx-2">
                <i class="fab fa-telegram-plane"></i>
              </a>

              <a href="https://medium.com/juggernaut-defi" class="mx-2">
                <i class="fab fa-medium-m"></i>
              </a>

              <a href="https://github.com/JGNDeFi" class="mx-2">
                <i class="fab fa-github"></i>
              </a>
            </div>

            <!-- text -->
            <div class="mb-none">
              contact@jgndefi.com
            </div>


          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

export default {
  name: 'siteFooter',
  components: {},
  props: [],
  data() {
    return {
      status_open_wechat: false,
    }
  },
  computed: {},
  watch: {},
  methods: {
    
  },
  created() {
    
  },
  //mounted() {},
  //beforeDestroy() {},
  //update() {},
  //activited() {},
  //beforeRouteUpdate() {},
  //filters: {},
};
</script>

<style lang="scss" scoped>
  @import '~@/assets/css/vars.scss';
  
  .site-footer{

    .footer-main{
      bottom: 0;
      position: absolute;
      bottom: 0;
      width: 100%;
      height: 100px;

    }
    .footer-holder{
      height: 100px;
    }

    .sp-bar{
      background-color: #000;
      color: #fff;
      a{
        color: inherit !important;
      }

      .sp-lins{
        font-size: 20px;
      }
    }
  }
</style>